/*
 * @Author: your name
 * @Date: 2020-08-28 17:06:45
 * @LastEditTime: 2020-12-15 13:18:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \1705\zbzt_live_sdk\src\network\api.js
 */
import commonFetch from './commonFetch.js';
import {getReportBaseUrl, getApiCloudBaseUrl, getCloudApiDomain, getApiChangeSdkUrl, timestampUrl} from '../config/config.js';
import util from '../util/util';

//获取信道服务器地址
export function getImServerAddress(param){
  return commonFetch(`${getCloudApiDomain()}/service/chat`, param, 'GET');
}

/**
 * @function 从三方服务器获取时间戳
 */
export function getNetworkTimestampApi(name = 'taobao'){
  return commonFetch(timestampUrl[name], 'GET');
}

// 获取云控参数
export function getCloudData(param){
  const data = {
    ...param,
    userType: param.userType === 'spy' ? 'student' : param.userType
  };
  return commonFetch(`${getApiCloudBaseUrl()}/rtccloud/class/init`, data, 'GET', null, util.getVerifySign1());
}

//获取初始化参数
export function getInitParams(param) {
  const types = {
    student: '/v1/play/init',
    teacher: '/v1/push/init',
    assistant: '/v1/push/init'
  };
  const { institutionId, userId, liveId, role} = param;
  return commonFetch(`${getApiCloudBaseUrl()}${types[role]}`, {institutionId, userId, liveId}, 'GET');
}

//获取新旧信道开关和地址
export function getSwitchDomain(param){
  return commonFetch(`${getApiCloudBaseUrl()}/v1/switch/domain`, param, 'GET');
}

export function dabanDataReport(param){
  return commonFetch(getReportBaseUrl(), param, 'POST');
}

//sdk切换（客户端直接调用）  根据上课情况手动操作，对单个组ID进行SDK切换
// export function changeSdkInRoom(param){
//   return commonFetch(`${getApiChangeSdkUrl()}/rtccloud/sdk/set/room/client`, param, 'FROMDATA');
// }
export function changeSdkInRoom(param){
  return commonFetch(`${getApiChangeSdkUrl()}/rtccloud/sdk/set/lecture/client`, param, 'FROMDATA');
}
